import React from 'react'
import { Box } from '@mui/material'

type Props = {
  priceLabel: string
  priceValue: number
  unit: string
}

export const PriceDisplay: React.FC<Props> = ({ priceLabel, priceValue, unit }) => {
  const price = (priceValue || 0)?.toLocaleString()
  const priceWithUnit = `${price} ${unit}`
  // const priceWithUnit = `${price}円`
  return (
    <Box>
      {priceLabel}
      {priceWithUnit}
    </Box>
  )
}
